import {
    putSubscribeCourse,
    putUnsubscribeCourse,
    // @ts-ignore
} from '@yandex-int/k-common/client/api';
import { showIntlMessageNotification, showNetworkError } from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';
import { all, put, takeLatest, call, select, throttle } from 'redux-saga/effects';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { courseSubscriptionsActions } from 'store/subscriptions/actions';

import { subscriptionModalActions } from './actions';

const MAX_RETRIES_COUNT = 3;
let retriesCount: Record<string, number> = {};
const REQUEST_THROTTLE_MS = 10;

export function* lessonViewSubscriptionModalSaga() {
    yield all([
        // троттлим сагу, чтобы подписка всегда происходила после выдачи занятия
        // см. https://st.yandex-team.ru/EDUCATION-20141
        throttle(
            REQUEST_THROTTLE_MS,
            subscriptionModalActions.confirmSubscriptionRequest,
            confirmSubscriptionRequestSaga
        ),
        takeLatest(subscriptionModalActions.confirmUnsubscriptionRequest, confirmUnsubscriptionRequestSaga),
        takeLatest(subscriptionModalActions.cancelSubscription, cancelSubscriptionSaga),
    ]);
}

function* confirmSubscriptionRequestSaga(
    action: ReturnType<typeof subscriptionModalActions.confirmSubscriptionRequest>
) {
    const { slug } = action.payload;
    try {
        const courseId: number = yield select(getCurrentYearCourseId);
        yield call(putSubscribeCourse, { slug, target: { course_id: courseId } });
        yield put(subscriptionModalActions.confirmSubscriptionSuccess({ slug }));
        yield put(courseSubscriptionsActions.getSubscriptionsByCourse({ courseId }));
        retriesCount[slug] = 0;
    } catch (e) {
        console.error(e);

        yield put(subscriptionModalActions.confirmSubscriptionError({ slug }));

        let retriesCountBySlug = retriesCount[slug] || 0;
        if (retriesCountBySlug < MAX_RETRIES_COUNT) {
            retriesCount[slug] = retriesCountBySlug + 1;
            yield put(subscriptionModalActions.confirmSubscriptionRequest({ slug }));
        }
    }

    yield put(subscriptionModalActions.toggleSubscriptionModal({ opened: false }));
}

function* confirmUnsubscriptionRequestSaga(
    action: ReturnType<typeof subscriptionModalActions.confirmUnsubscriptionRequest>
) {
    const { slug } = action.payload;
    try {
        const courseId: number = yield select(getCurrentYearCourseId);
        yield call(putUnsubscribeCourse, { slug, target: { course_id: courseId } });
        yield put(subscriptionModalActions.confirmUnsubscriptionSuccess({ slug }));
        yield put(
            showIntlMessageNotification({
                closeDelay: COMMON_NOTIFICATION_DELAY,
                gravity: GRAVITIES.BOTTOM,
                messageId: 'toast.subscriptions.subscription.successfullyCancelled',
                withExplicitClose: true,
                theme: NOTIFICATION_THEMES.TOAST,
            })
        );
        yield put(courseSubscriptionsActions.getSubscriptionsByCourse({ courseId }));
    } catch (e) {
        console.error(e);

        yield put(subscriptionModalActions.confirmSubscriptionError({ slug }));
        yield put(showNetworkError());
    }

    yield put(subscriptionModalActions.toggleSubscriptionModal({ opened: false }));
}

function* cancelSubscriptionSaga() {
    yield put(subscriptionModalActions.toggleSubscriptionModal({ opened: false }));
}
